export const pointerStatus = { ON: "1", OFF: "2", ENABLED: "3", DISABLED: "4" };
export const STATUS = { ON: "ON", OFF: "OFF", ENABLED: "ENABLED", DISABLED: "DISABLED" };
export const AGENTDEFAULTCOLOR = "#00ff00";
export const POINTERDEFAULTCOLORS = ["#ff0000", "#00FFFF", "#ff00ff", "#26bd7f", "#873AE7", "#1EA1DF", "#B4A017", "#C47E25", "#4C5B6F", "#E9FF5B"];
